/* unplugin-vue-components disabled */import script from "./Account.vue?vue&type=script&lang=ts&setup=true"
export * from "./Account.vue?vue&type=script&lang=ts&setup=true"

import "./Account.vue?vue&type=style&index=0&id=6cd0e458&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6cd0e458"]])

export default __exports__